import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { Dropdown, Icon, Modal } from 'antd';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import MenuWithRemovedItems from './components/MenuWithRemovedItems/MenuWithRemovedItems';
import { savedFiltersKey } from '../../queries/useSavedFilters';
import { filtersData } from '../../constants/filtersData';
import useResetFilter from '../../hooks/useResetFilter';
import useDeleteFilterMutation from '../../mutations/useDeleteFilterMutation';
import { useSaveDefaultFilter } from '../../mutations/useSaveDefaultFilterMutation';
import styles from './SavedFiltersDropdown.module.scss';


const { confirm } = Modal;

const SavedFiltersDropdown = ({
  defaultFilter,
  setDefaultFilter,
  buttonText,
  resetButtonDisabled,
}) => {
  const [visible, setVisible] = useState(false);

  const history = useHistory();

  const queryClient = useQueryClient();

  const savedFiltersState = queryClient.getQueryState(savedFiltersKey());

  const savedFilters = savedFiltersState?.data;

  const { mutate: deleteFilterMutate } = useDeleteFilterMutation({
    onSuccess: () => queryClient.invalidateQueries(savedFiltersKey()),
  });

  const { mutate: saveDefaultFilter } = useSaveDefaultFilter({
    onSuccess: () => queryClient.invalidateQueries(savedFiltersKey())
  })

  const handleMenuClick = ({ item, needSave = true }) => {
    const filters = item.props.value?.filter;

    if (filters) {
      const searchParams = new URLSearchParams(history.location.search);

      Array.from(searchParams.keys()).forEach((key) =>
        searchParams.delete(key)
      );

      Object.entries(filters).forEach(([key, value]) => {
        const filterData = filtersData[key];
        searchParams.set(key, filterData.serialize(value));
      });

      history.push({
        search: searchParams.toString(),
      });
    }

    if (needSave) {
      const defaultFilterValue = {
        id: item.props.value?.id,
        value: true,
        type: 'save'
      }
      saveDefaultFilter(defaultFilterValue)
    }

    setVisible(false);
  };

  const handleDeleteFilter = (filterData) => {
    confirm({
      title: `Удалить фильтр "${filterData.name}"?`,
      content: 'Это действие нельзя будет отменить',
      onOk: () => deleteFilterMutate({ filterId: filterData.id }),
      onCancel: () => {},
    });

    setVisible(false);
  };

  const resetFilter = useResetFilter()

  const handleResetFilter = () => {
    resetFilter();
    saveDefaultFilter({ id: defaultFilter?.id, value: false, type: 'unsave' })
  };

  const autoSetDefaultFilter = async () => {
    if (savedFilters?.length) {
      await history.replace({ search: '' });

      const defaultFilter = savedFilters.find((filter) => filter.isDefault);
      if (defaultFilter) {
        handleMenuClick({
          item: { props: { value: defaultFilter } },
          needSave: false,
        });
        setDefaultFilter(defaultFilter)
      }
    }
  }

  useEffect(() => {
    autoSetDefaultFilter()
  }, []);


  return (
    <Dropdown
      overlay={
        <MenuWithRemovedItems
          emptyText="Нет сохраненных фильтров"
          resetButtonText="Сбросить фильтр"
          items={savedFilters}
          resetButtonDisabled={resetButtonDisabled}
          handlers={{
            onDeleteItem: handleDeleteFilter,
            onReset: handleResetFilter,
            onMenuClick: handleMenuClick,
          }}
        />
      }
      trigger={['click']}
      disabled={savedFiltersState?.isFetching}
      visible={visible}
      onVisibleChange={(visible) => setVisible(visible)}
    >
      <RoundedButton
        iconRight={<Icon type="caret-down" />}
        text={buttonText}
        type="primary-orange"
        className={styles.savedFiltersBtn}
      />
    </Dropdown>
  );
};

export default SavedFiltersDropdown;
